module.exports = __webpack_public_path__ + "static/media/stethophyma_grossum.60ad7089.jpg";